import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';

export interface MediaData {
  mediaPath: string | null;
}

@Component({
    selector: 'sentry-media-dialog',
    templateUrl: 'media-dialog.component.html',
    styleUrls: ['./media-dialog.component.scss'],
    standalone: true,
    imports: [MatDialogModule, MatButtonModule]
})
export class MediaDialogComponent {
  isVideo = (path: string) => path.includes('.mp4') || path.includes('.mov');
  isImage = (path: string) => path.includes('.jpeg') || path.includes('.png');

  constructor(@Inject(MAT_DIALOG_DATA) readonly data: MediaData) {}
}
